/* MCR header: sticky (Dawn-compatible <sticky-header>), shrink + glass, transparent overlay,
   hover-intent mega/dropdown menus with keyboard support, and the off-canvas <mcr-drawer>. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopMq = window.matchMedia('(min-width: 990px)');
  var lastPointer = 'mouse';
  doc.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, { capture: true, passive: true });

  function after(ms, fn) { return reduceMotion.matches ? (fn(), 0) : setTimeout(fn, ms); }
  function anyModalOpen() { return !!doc.querySelector('.mcr-modal.is-open, mcr-drawer.is-open, mcr-search.is-sheet'); }
  function unlock() { if (!anyModalOpen()) root.classList.remove('mcr-lock'); }

  /* ---------------- Menus ---------------- */
  function initMenus(header) {
    var items = Array.prototype.slice.call(header.querySelectorAll('[data-mcr-menu-item]'));
    if (!items.length) return { closeAll: function () {} };
    var delay = parseInt(header.getAttribute('data-hover-delay'), 10) || 0;
    var openItem = null;
    var openTimer = 0;
    var closeTimer = 0;

    // mega panels arrive as inert <template>s — build one the first time it opens
    function build(panel) {
      var t = panel && panel.querySelector(':scope > template[data-mcr-panel-content]');
      if (!t) return;
      panel.insertBefore(t.content.cloneNode(true), t);
      t.remove();
    }
    var nav = header.querySelector('.mcr-header__nav') || header;
    ['pointerenter', 'focusin'].forEach(function (ev) {
      nav.addEventListener(ev, function () { items.forEach(function (it) { build(it.querySelector('[data-mcr-panel]')); }); }, { once: true, passive: true });
    });

    function parts(item) {
      return {
        panel: item.querySelector('[data-mcr-panel]'),
        toggle: item.querySelector('[data-mcr-menu-toggle]'),
        link: item.querySelector('[data-mcr-menu-link]'),
      };
    }

    function open(item, focusFirst) {
      clearTimeout(closeTimer);
      if (openItem === item) {
        if (focusFirst) focusFirstIn(parts(item).panel);
        return;
      }
      var instantSwap = !!openItem;
      if (openItem) close(openItem, true);
      var p = parts(item);
      if (!p.panel) return;
      build(p.panel);
      p.panel.hidden = false;
      void p.panel.offsetWidth; // commit start state so the reveal transition runs
      item.classList.add('is-open');
      if (instantSwap) item.classList.add('is-swap');
      p.toggle && p.toggle.setAttribute('aria-expanded', 'true');
      openItem = item;
      header.preventHide = true;
      header.classList.add('is-menu-open');
      header.setRaised(true);
      if (focusFirst) focusFirstIn(p.panel);
    }

    function close(item, instant) {
      if (!item) return;
      var p = parts(item);
      item.classList.remove('is-open', 'is-swap');
      p.toggle && p.toggle.setAttribute('aria-expanded', 'false');
      var hide = function () { if (!item.classList.contains('is-open') && p.panel) p.panel.hidden = true; };
      instant ? hide() : after(280, hide);
      if (openItem === item) {
        openItem = null;
        header.preventHide = false;
        header.classList.remove('is-menu-open');
        header.setRaised(false);
      }
    }

    function focusFirstIn(panel) {
      var f = panel && panel.querySelector('a[href], button:not([disabled])');
      if (f) f.focus();
    }

    items.forEach(function (item) {
      var p = parts(item);
      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !desktopMq.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : delay);
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { if (openItem === item) close(item); }, 220);
      });
      if (p.toggle) {
        p.toggle.addEventListener('click', function (e) {
          e.preventDefault();
          item.classList.contains('is-open') ? close(item) : open(item, e.detail === 0);
        });
      }
      if (p.link) {
        // Touch on desktop widths (tablets): first tap opens the panel, second tap follows the link.
        p.link.addEventListener('click', function (e) {
          if (lastPointer !== 'mouse' && lastPointer !== 'pen' && !item.classList.contains('is-open')) {
            e.preventDefault();
            open(item);
          }
        });
      }
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && item.classList.contains('is-open')) {
          e.stopPropagation();
          close(item, true);
          (p.toggle || p.link).focus();
        } else if (e.key === 'ArrowDown' && (e.target === p.link || e.target === p.toggle)) {
          e.preventDefault();
          open(item, true);
        }
      });
      item.addEventListener('focusout', function (e) {
        if (item.classList.contains('is-open') && e.relatedTarget && !item.contains(e.relatedTarget)) close(item);
      });
      item.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mcr-mega-close]')) return;
        e.preventDefault();
        close(item, true);
        (p.toggle || p.link).focus({ preventScroll: true });
      });
    });

    // Left/right arrows move between top-level items.
    var nav = header.querySelector('.mcr-nav__list');
    if (nav) {
      nav.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var links = Array.prototype.slice.call(nav.querySelectorAll(':scope > li > .mcr-nav__link'));
        var i = links.indexOf(e.target);
        if (i === -1) return;
        e.preventDefault();
        var next = links[(i + (e.key === 'ArrowRight' ? 1 : -1) + links.length) % links.length];
        next.focus();
      });
    }

    doc.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) close(openItem);
    });
    var scrim = header.querySelector('[data-mcr-scrim]');
    if (scrim) scrim.addEventListener('pointerenter', function () { if (openItem && lastPointer === 'mouse') close(openItem); });
    desktopMq.addEventListener && desktopMq.addEventListener('change', function () { if (openItem) close(openItem, true); });

    // Theme editor: open the mega panel of the selected block.
    doc.addEventListener('shopify:block:select', function (e) {
      var panel = header.querySelector('[data-mcr-block-id="' + e.detail.blockId + '"]');
      if (panel) open(panel.closest('[data-mcr-menu-item]'));
    });
    doc.addEventListener('shopify:block:deselect', function (e) {
      var panel = header.querySelector('[data-mcr-block-id="' + e.detail.blockId + '"]');
      if (panel) close(panel.closest('[data-mcr-menu-item]'), true);
    });

    return { closeAll: function () { if (openItem) close(openItem, true); } };
  }

  /* ---------------- Sticky header (keeps Dawn's public API) ---------------- */
  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      class StickyHeader extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.header = this.closest('.section-header') || doc.querySelector('.section-header');
          this.type = this.getAttribute('data-sticky-type') || 'none';
          this.isOverlay = this.classList.contains('mcr-header--overlay');
          this.preventHide = false;
          this.preventReveal = false;
          this.currentScrollTop = 0;
          this.raiseCount = 0;
          this.headerBounds = { top: 0, bottom: 0 };

          this.setHeaderHeight = this.setHeaderHeight.bind(this);
          this.setHeaderHeight();
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.setHeaderHeight);
            this.ro.observe(this.header);
          } else {
            window.addEventListener('resize', this.setHeaderHeight);
          }

          if (this.type === 'always') this.header.classList.add('shopify-section-header-sticky');

          var rect = this.header.getBoundingClientRect();
          var y = window.pageYOffset;
          this.headerBounds = { top: rect.top + y, bottom: rect.bottom + y };

          this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

          this.ticking = false;
          this.onScrollHandler = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.ticking = false;
              this.onScroll();
            });
          };
          window.addEventListener('scroll', this.onScrollHandler, { passive: true });
          this.onScroll();

          this.menus = initMenus(this);
          this.classList.add('is-ready');
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScrollHandler);
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          if (this.ro) this.ro.disconnect();
        }

        setHeaderHeight() {
          root.style.setProperty('--header-height', this.header.offsetHeight + 'px');
        }

        setRaised(on) {
          this.raiseCount = Math.max(0, this.raiseCount + (on ? 1 : -1));
          this.header.classList.toggle('mcr-raise', this.raiseCount > 0);
          if (this.isOverlay) this.classList.toggle('is-solid', this.raiseCount > 0 || this.classList.contains('is-scrolled'));
        }

        searchOpen() {
          return Array.prototype.some.call(this.querySelectorAll('mcr-search, predictive-search'), function (s) { return s.isOpen; });
        }

        onScroll() {
          var scrollTop = window.pageYOffset || root.scrollTop;
          var scrolled = scrollTop > Math.max(8, this.headerBounds.top + 4);
          if (scrolled !== this.classList.contains('is-scrolled')) {
            this.classList.toggle('is-scrolled', scrolled);
            this.header.classList.toggle('mcr-scrolled', scrolled);
            if (this.isOverlay) this.classList.toggle('is-solid', scrolled || this.raiseCount > 0);
          }

          if (this.type !== 'on-scroll-up') {
            this.currentScrollTop = scrollTop;
            return;
          }
          if (this.searchOpen()) return;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventHide) this.hide();
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              this.reveal();
            } else {
              clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
              this.hide();
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.reset();
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
          if (this.type !== 'on-scroll-up') return;
          this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          if (this.menus) this.menus.closeAll();
          this.querySelectorAll('localization-form').forEach(function (f) { if (f.hidePanel && f.elements && f.elements.panel && !f.elements.panel.hidden) f.hidePanel(); });
        }

        reveal() {
          if (this.type !== 'on-scroll-up') return;
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
          if (this.type !== 'on-scroll-up') return;
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
      }
    );
  }

  /* ---------------- Off-canvas drawer ---------------- */
  if (!customElements.get('mcr-drawer')) {
    customElements.define(
      'mcr-drawer',
      class McrDrawer extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.panel = this.querySelector('.mcr-drawer__panel');
          this.headerEl = this.closest('sticky-header');
          var scope = this.headerEl || doc;
          this.openers = Array.prototype.slice.call(scope.querySelectorAll('[data-mcr-drawer-open]'));
          this.openers.forEach((btn) => {
            btn.addEventListener('click', () => this.open(btn));
            // build the menu the moment a finger/pointer reaches the button, so opening stays instant
            ['pointerdown', 'touchstart', 'focus'].forEach((ev) => btn.addEventListener(ev, () => this.build(), { once: true, passive: true }));
          });

          this.addEventListener('click', (e) => {
            var t = e.target;
            if (t.closest('[data-mcr-drawer-close]')) {
              e.preventDefault();
              this.close();
            } else if (t.closest('[data-mcr-search-open]')) {
              this.close(false);
            } else if (t.closest('[data-mcr-acc-toggle]')) {
              this.toggleAcc(t.closest('[data-mcr-acc-toggle]'));
            }
          });
          // Account links open Razorpay's OTP login over the page on press, and it cancels the click
          // on touch — so close the drawer on pointerup too (click still covers keyboard).
          ['pointerup', 'click'].forEach((type) => this.addEventListener(type, (e) => {
            if (e.target.closest('a[href*="/account"]')) this.close(false);
          }, true));
          this.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
              // let an open localization list close first
              if (e.target.closest && e.target.closest('.disclosure__list-wrapper:not([hidden])')) return;
              e.preventDefault();
              this.close();
            } else if (e.key === 'Tab') {
              this.trap(e);
            }
          });
          desktopMq.addEventListener && desktopMq.addEventListener('change', () => { if (desktopMq.matches && this.isOpen) this.close(false); });
        }

        build() {
          var t = this.querySelector('template[data-mcr-drawer-content]');
          if (!t) return;
          t.parentNode.insertBefore(t.content.cloneNode(true), t);
          t.remove();
          if (window.MCR && window.MCR.wishlistSync) window.MCR.wishlistSync();
        }

        toggleAcc(btn) {
          var panel = doc.getElementById(btn.getAttribute('aria-controls'));
          var on = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (panel) panel.classList.toggle('is-open', on);
        }

        focusables() {
          return Array.prototype.filter.call(
            this.panel.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])'),
            function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; }
          );
        }

        trap(e) {
          var f = this.focusables();
          if (!f.length) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (e.shiftKey && (doc.activeElement === first || doc.activeElement === this.panel)) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && doc.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }

        open(trigger) {
          if (this.isOpen) return;
          this.build();
          this.isOpen = true;
          this.trigger = trigger || null;
          clearTimeout(this.hideTimer);
          this.hidden = false;
          void this.offsetWidth;
          this.classList.add('is-open');
          root.classList.add('mcr-lock');
          this.openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
          if (this.headerEl) {
            this.headerEl.preventHide = true;
            this.headerEl.setRaised && this.headerEl.setRaised(true);
          }
          var closeBtn = this.querySelector('.mcr-drawer__close');
          after(60, function () { closeBtn && closeBtn.focus({ preventScroll: true }); });
        }

        close(returnFocus) {
          if (!this.isOpen) return;
          this.isOpen = false;
          this.classList.remove('is-open');
          this.openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
          var self = this;
          this.hideTimer = after(420, function () { if (!self.isOpen) self.hidden = true; });
          unlock();
          if (this.headerEl) {
            this.headerEl.preventHide = false;
            this.headerEl.setRaised && this.headerEl.setRaised(false);
          }
          if (returnFocus !== false && this.trigger) this.trigger.focus({ preventScroll: true });
        }
      }
    );
  }

  // The account `open` event is composed but does not bubble, so listen during capture (from Dawn).
  doc.addEventListener(
    'open',
    function (event) {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      var bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', bottom + 'px');
    },
    true
  );
})();

